export const getPhotoSize = async (photo) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    const size = {};
    try {
      const objectUrl = URL.createObjectURL(photo.file);
      img.onload = function _onload() {
        size.width = this.width;
        size.height = this.height;
        URL.revokeObjectURL(objectUrl);
        resolve(size);
      };
      img.src = objectUrl;
      img.onerror = function _onerror(e) {
        reject(e);
      };
    } catch (e) {
      reject(e);
    }
  });
